// extracted by mini-css-extract-plugin
export default {"wrapper":"rn-z","response":"sn-z","error":"tn-z","disabled":"un-z","buttons":"vn-z","feedbackQuestionSection":"wn-z","yesNoWrapper":"xn-z"};